import { render, staticRenderFns } from "./VideoProjectList.vue?vue&type=template&id=448c3300&scoped=true"
import script from "./VideoProjectList.vue?vue&type=script&lang=js"
export * from "./VideoProjectList.vue?vue&type=script&lang=js"
import style0 from "./VideoProjectList.vue?vue&type=style&index=0&id=448c3300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c3300",
  null
  
)

export default component.exports